import { render } from "./ResourceDetailsDialog.vue?vue&type=template&id=35e32efc"
import script from "./ResourceDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ResourceDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/cube-viewer/cube-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__